import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentVault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_95_2830",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 26,
		height: 26,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_95_2830)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.1878 21.1999V13.4666L5.41699 9.54571V17.0917C5.41699 17.1471 5.43089 17.1992 5.4587 17.2479C5.48651 17.2965 5.52812 17.3381 5.58355 17.3728L12.1878 21.1999ZM13.8128 21.1999L20.4171 17.3728C20.4725 17.3381 20.5141 17.2965 20.542 17.2479C20.5698 17.1992 20.5837 17.1471 20.5837 17.0917V9.54571L13.8128 13.4666V21.1999ZM12.0213 22.9728L4.77133 18.7998C4.46294 18.6222 4.22262 18.3847 4.05037 18.0875C3.87812 17.7902 3.79199 17.4637 3.79199 17.1082V8.89165C3.79199 8.53614 3.87812 8.20969 4.05037 7.91232C4.22262 7.61512 4.46294 7.37769 4.77133 7.20002L12.0213 3.02703C12.3295 2.84918 12.6558 2.76025 13.0003 2.76025C13.3448 2.76025 13.6712 2.84918 13.9794 3.02703L21.2293 7.20002C21.5377 7.37769 21.778 7.61512 21.9503 7.91232C22.1225 8.20969 22.2087 8.53614 22.2087 8.89165V17.1082C22.2087 17.4637 22.1225 17.7902 21.9503 18.0875C21.778 18.3847 21.5377 18.6222 21.2293 18.7998L13.9794 22.9728C13.6712 23.1507 13.3448 23.2396 13.0003 23.2396C12.6558 23.2396 12.3295 23.1507 12.0213 22.9728ZM17.1774 9.64159L19.6899 8.19994L13.1669 4.42696C13.1115 4.3923 13.0559 4.37496 13.0003 4.37496C12.9447 4.37496 12.8892 4.3923 12.8338 4.42696L10.4816 5.78113L17.1774 9.64159ZM13.0003 12.0666L15.5191 10.6082L8.82949 6.7415L6.31074 8.19994L13.0003 12.0666Z",
			fill: "#71839B"
		})
	})]
});
export default SvgDocumentVault;
